import { FINISH_SEQUENCE, FLUSH_SEQUENCE, START_SEQUENCE } from './sequences.actionTypes';

export const actionCreators = {
	doFlushSequences: () => ({
		type: FLUSH_SEQUENCE,
	}),
	doStartSequence: (sequenceName: string) => ({
		type: START_SEQUENCE,
		sequenceName,
	}),
	doFinishSequence: (sequenceName: string) => ({
		type: FINISH_SEQUENCE,
		sequenceName,
	}),
};

export type SequencesActionType =
	| ReturnType<typeof actionCreators.doFlushSequences>
	| ReturnType<typeof actionCreators.doStartSequence>
	| ReturnType<typeof actionCreators.doFinishSequence>;
